<template>
  <b-card>
    <b-row>
      <b-col cols="8">
        <b-form-group id="title-gr" label="عنوان:" label-for="title">
          <b-form-input id="title" v-model="Setting.title" required placeholder="عنوان"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="add_gr_code-gr" label="اضافه کردن کد گروه:" label-for="add_gr_code">
          <div class="form-control">
            <b-form-checkbox id="add_gr_code" v-model="Setting.add_gr_code">بلی</b-form-checkbox>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group id="len_g-gr" label="طول کد گروه:" label-for="len_g">
          <b-form-input id="len_g" v-model="Setting.len_g" required placeholder></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="len_k-gr" label="طول کد حساب کل:" label-for="len_k">
          <b-form-input id="len_k" v-model="Setting.len_k" required placeholder></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="len_m-gr" label="طول کد معین اول:" label-for="len_m">
          <b-form-input id="len_m" v-model="Setting.len_m" required placeholder></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="len_m2-gr" label="طول کد معین دوم:" label-for="len_m2">
          <b-form-input id="len_m2" v-model="Setting.len_m2" required placeholder></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group id="len_t1-gr" label="طول کد تفضیلی اول:" label-for="len_t1">
          <b-form-input id="len_t1" v-model="Setting.len_t1" required placeholder></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="len_t2-gr" label="طول کد تفضیلی دوم:" label-for="len_t2">
          <b-form-input id="len_t2" v-model="Setting.len_t2" required placeholder></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="len_t3-gr" label="طول کد تفضیلی سوم:" label-for="len_t3">
          <b-form-input id="len_t3" v-model="Setting.len_t3" required placeholder></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="char-gr" label="کاراکتر جداکننده کد:" label-for="char">
          <b-form-input id="char" v-model="Setting.char" required placeholder></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button variant="success" @click="SaveSetting()">ذخیره</b-button>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import httpHelper from "../../../helpers/httpHelper";
export default {
  name: "AccSetting",
  data() {
    return {
      Setting: {
        title: "",
        len_g: 0,
        len_k: 0,
        len_m: 0,
        len_m2: 0,
        len_t1: 0,
        len_t2: 0,
        len_t3: 0,
        char: "",
        add_gr_code: false
      }
    };
  }, 
  created() {
    if (this.$route.params.id) {
      httpHelper
        .getData("accsetting?id=" + this.$route.params.id)
        .then(res => {
          this.Setting = res.result;
          console.log(res);
        });
    }
  },
  methods: {
    SaveSetting() {
      httpHelper.postData("accsetting", this.Setting).then(res => {
        this.$router.push("/rp/16");
      });
    }
  }
};
</script>